import React, { useState, useRef } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import { useAuth } from "../utility/auth";
import {
    Container,
    Grid,
    useTheme,
    Box,
    Stack,
    IconButton,
} from "@mui/material";
import * as Yup from "yup";
import Load from "../components/FormsUI/Loader/index";
import Controls from "../components/FormsUI";
import CustomizedSnackbars from "../components/Alert";
import MemberGroupController from "../controller/MemberGroup";
import DeleteIcon from "@mui/icons-material/Delete";
import EXCEL_ICON from "../assets/images/excel_icon.png";
import ExceptionHandlerController from "../controller/ErrorLogsController";
import excelPath from "../assets/Sample_Member_Excel_File/whatsAppGroupSample.xlsx";

import "../css/style.css";
import { tokens } from "../theme";

const INITIALFORM = {
    groupName: "",
    groupMembers: "",
};
// const FAMILYNAME_INITIALFORM = { familyName: "" };
const VALIDATION_INITIALFORM = Yup.object().shape({
    groupName: Yup.string()
        .required("Group Name  is required")
        .trim("White space is not allowed")
        .strict(true)
        .max(100, "Group Name should not excceed 50 character"),
    groupMembers: Yup.string().required("Excel file Upload is required"),
});

const WhatsAppGroup = () => {
    const fileInputRef = useRef(null);
    const theme = useTheme();
    const auth = useAuth();
    const user = auth.decoder(sessionStorage.getItem("user"));
    const { data, token } = user;
    const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
    const [sectionGrid, setSectionGrid] = useState([]);
    const [loader, setLoader] = useState(false);
    const [, setIsDropdown] = useState(false);

    const [, setMemberID] = useState("");
    const [, setFileExcel] = React.useState();
    const memberGroupController = new MemberGroupController();
    const exceptionHandlerController = new ExceptionHandlerController();
    // debugger
    const { userid: userId, tenantid: tenantId } = data.UserInfo;
    const colors = tokens(theme.palette.mode);
    const [, setPopUp] = useState(false);
    const [popup1, setPopUp1] = useState(false);



    React.useEffect(() => {
        getSectionsGrid();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const showAlert = (type, msg) => {
        const notify = { ...alert };
        notify.counter = notify.counter + 1;
        notify.type = type;
        notify.msg = msg;
        setAlert(notify);
    };
    const saveFile = (e, setFieldValue, field) => {
        let caughtError;
        try {
            const fileSizeInBytes = e?.target?.files[0]?.size;
            const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
            if (fileSizeInMB > 4) {
                showAlert("error", "Document size should not exceed 4MB");
                return;
            }
            const allowedExtensions = [
                "xlsx",
                "xlam",
                "xml",
                "xls",
                "xlt",
                "xltm",
                "xltx",
                "xlsb",
                "xlsm",
            ];
            const fileName = e?.target?.files?.[0]?.name;
            const fileExtension = fileName?.split(".").pop()?.toLowerCase();

            if (field === "groupMembers" && allowedExtensions.includes(fileExtension)) {
                setFileExcel(() => e?.target?.files?.[0]);
                setFieldValue("groupMembers", e?.target?.files?.[0]);
            } else {
                showAlert("error", "Only Excel files (xlsx, xls) are allowed");
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = { logData, module: "ResearchExcel saveFile method" };
            exceptionHandlerController.HandleException(logError);
        }
    };



    const downloadExcel = () => {
        const filePath = excelPath;
        const downloadLink = document.createElement("a");
        downloadLink.href = filePath;
        downloadLink.download = "sample-file.xlsx";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };


    const submitMemberValues = (values, resetForm, setFieldValue) => {
        // debugger
        let caughtError;
        try {
            const formData = new FormData();
            formData.append("groupName", values.groupName);
            formData.append("tenantId", tenantId); // if needed
            formData.append("userId", userId); // if needed
            formData.append("groupMembers", values.groupMembers); // File object

            memberGroupController.CreateMemberGroup(formData, token)
                .then((resultObj) => {
                    if (resultObj.status === 201) {
                        resetForm({ values: INITIALFORM });
                        if (fileInputRef.current) {
                            fileInputRef.current.value = ''; // clear file input manually
                        }
                        setFieldValue('groupMembers', '');
                        getSectionsGrid();
                        showAlert('success', resultObj?.data?.message)
                    } else {
                        showAlert("error", resultObj?.response?.data?.message);
                    }
                })
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "WhatsAppGroup page submitValues method",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };

    const columns = [
        { headerName: "groupID", field: "groupID", hide: true, filterable: false },
        { headerName: "Total Member", field: "excelDataLength", width: 200 },
        { headerName: "Group Name", field: "groupName", width: 200 },
        { headerName: "Create Date", field: "createdDate", width: 130 },
        {
            field: "action",
            headerName: "Action",
            width: 180,
            sortable: false,
            disableExport: true,
            filterable: false,
            disableClickEventBubbling: true,
            renderCell: (params) => {
                const onClick = async (e, type) => {
                    let caughtError;
                    try {
                        setAlert({ counter: 0, type: "", msg: "" });
                        const currentRow = params.row;

                        if (type === "Edit") {
                            // setIsDropdown(false);
                            setPopUp(true);
                            // handleData();
                            // debugger;
                            memberGroupController
                                .getContentDataById(token, currentRow.id)
                                .then((getDataAndUpdate) => {
                                    if (getDataAndUpdate.status === 200) {
                                        // console.log(' resultObj:', getDataAndUpdate);
                                    }
                                })
                            // memberGroupController.updateMemberGroup(token, currentRow.id)
                            // handleData()
                        } else {
                            const deleteData = await memberGroupController.deteleMemberGroup(token, currentRow.id);
                            // debugger
                            showAlert('success', deleteData?.data?.message)
                            getSectionsGrid();

                        }
                        // if (type === "Edit") {
                        //     setIsDropdown(false);
                        //     // setUpdatedValues();
                        //     setMemberID();
                        //     setLoader(() => true);
                        //     let tempData = {};
                        //     memberShipController
                        //         .GetMemberById(currentRow.id, token)
                        //         .then((resultObj) => {
                        //             setLoader(() => false);
                        //             const responseData = resultObj?.data?.body ?? {};
                        //             if (resultObj.status === 200) {
                        //                 tempData = {
                        //                     memberGroup: responseData?.memberGroup ?? 'NA',
                        //                     totelMember: responseData?.totelMember ?? "",
                        //                     // mobileNumber: responseData?.mobileNumber ?? "",
                        //                 };
                        //                 setMemberID(responseData?.memberId);
                        //                 // setUpdatedValues(tempData);

                        //             } else {
                        //                 showAlert("error", resultObj?.response?.data?.message);
                        //             }
                        //         });
                        //     handleData();
                        // } else {
                        //     memberShipController
                        //         .DeleteMemberID(currentRow.id, token)
                        //         .then((resultObj) => {
                        //             setLoader(() => false);
                        //             if (resultObj.status === 200) {
                        //                 showAlert("success", resultObj?.data?.message);
                        //                 getSectionsGrid();
                        //             } else {
                        //                 showAlert("error", resultObj?.response?.data?.message);
                        //             }
                        //         });
                        // }
                    } catch (error) {
                        caughtError = error;
                        let logData = {};
                        logData.message = caughtError?.message;
                        logData.stack = caughtError?.stack;
                        let logError = {
                            logData,
                            module: "WhatsAppGroup page onClick(Edit) method",
                        };
                        exceptionHandlerController.HandleException(logError);
                    }
                };

                return (
                    <Stack direction="row" spacing={1}>
                        <>
                            {/* <IconButton>
                                <EditIcon
                                    type="button"
                                    color="primary"
                                    id="Edit"
                                    onClick={(e) => onClick(e, "Edit")}
                                />
                            </IconButton> */}
                            <IconButton>
                                <DeleteIcon
                                    type="button"
                                    color="primary"
                                    id="Delete"
                                    onClick={(e) => onClick(e, "Delete")}
                                />
                            </IconButton>
                        </>
                    </Stack>
                );
            },
        },
    ];

    const handlePopup1 = (value) => setPopUp1(value);

    const getSectionsGrid = () => {
        let caughtError;
        // debugger
        memberGroupController
            .getMemberGroupList(token, userId)
            .then((resultObj) => {
                setLoader(() => false);
                if (resultObj.status === 200) {
                    const userData = resultObj?.data?.data?.map((item) => {
                        const { _id: id, ...rest } = item;
                        return { id, ...rest };
                    });
                    // getExcelData(resultObj?.data?.body);
                    setSectionGrid(() => userData);
                } else {
                    showAlert("error", resultObj?.response?.data?.message);
                }
            })
            .catch((error) => {
                caughtError = error;
                let logData = {};
                logData.message = caughtError?.message;
                logData.stack = caughtError?.stack;
                let logError = {
                    logData,
                    module: "WhatsAppGroup page inside getSectionsGrid method",
                };
                exceptionHandlerController.HandleException(logError);
            });
    };


    const handleData1 = () => setPopUp1(true);
    const CreateGroup = (e) => {
        setMemberID("");
        setIsDropdown(false);
        handleData1();
    };



    if (loader) return <Load />;
    return (
        <Box
            sx={{
                "& .formBg": {
                    border: `1px solid ${colors.grey[900]}`,
                    background: `${colors.primary[400]}`,
                },
                "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
                "& .MuiGrid-root.Mui-heading h2": {
                    color: `${colors.primary[200]} !important`,
                },
            }}        >
            <Grid container>
                <Grid className="breadcrumb-section">
                    <Grid className="breadcrumb-container">
                        <Grid className="Mui-li">
                            <nav className="Mui-nav" aria-label="breadcrumb">
                                <ol className="">
                                    <li className="MuiBreadcrumbs-li">
                                        <h6 className="breadsub">WhatsApp</h6>
                                    </li>
                                    <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                                        /
                                    </li>
                                    <li className="MuiBreadcrumbs-li">
                                        <h6>Members Group</h6>
                                    </li>
                                </ol>
                            </nav>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={12} className="adduser au1 pt-2">
                    <Controls.ActionButton onClick={CreateGroup}>
                        Create Group Member
                    </Controls.ActionButton>
                </Grid>
                <Grid item xs={12} className="formBg">
                    <Container maxWidth="md" className="formClwidth">
                        <div>
                            <Controls.Grid
                                columns={columns}
                                data={sectionGrid}
                                fileName={"Edit Content"}
                            />
                            {popup1 && (
                                <Controls.Popup
                                    title="Create Group"
                                    minHeight={100}
                                    openPopup={popup1}
                                    setOpenPopup={handlePopup1}
                                >
                                    <div>
                                        <Formik
                                            enableReinitialize
                                            initialValues={INITIALFORM}
                                            validationSchema={VALIDATION_INITIALFORM}
                                            onSubmit={(values, { resetForm, setFieldValue }) => submitMemberValues(values, resetForm, setFieldValue)}
                                        >
                                            {({
                                                values,
                                                setFieldValue,
                                                handleChange,
                                                setFieldTouched,
                                            }) => (
                                                <Form>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={6} md={4}>
                                                            <Controls.ActionButton
                                                                onClick={() => {
                                                                    downloadExcel();
                                                                }}
                                                            >
                                                                <div>
                                                                    <img
                                                                        src={EXCEL_ICON}
                                                                        width={35}
                                                                        alt="EXCEL_ICON"
                                                                    />
                                                                </div>
                                                                <span className="button-four">
                                                                    Donwload Sample
                                                                </span>
                                                            </Controls.ActionButton>
                                                        </Grid>
                                                        <Grid container direction="column" alignItems="center" spacing={2} >
                                                            <Grid item xs={12}>
                                                                <h3 className="">Data Upload</h3>
                                                                <Grid item xs={12} md={12}>
                                                                    <Controls.Textfield
                                                                        name="groupName"
                                                                        label="Group Name *"
                                                                        type="string"
                                                                        autoFocus
                                                                        inputProps={{ maxLength: 50 }}
                                                                    />
                                                                </Grid>
                                                                <br />
                                                                <Grid item xs={12} md={2}>
                                                                    <input
                                                                        type="file"
                                                                        ref={fileInputRef}
                                                                        onChange={(e) => {
                                                                            saveFile(e, setFieldValue, "groupMembers");
                                                                        }}
                                                                        className="fileupload ipfile"
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={6} md={6}>
                                                                    <ErrorMessage name="groupMembers">
                                                                        {(msg) => (
                                                                            <div style={{ color: "#d32f2f", fontSize: "15px", }}>
                                                                                {msg}
                                                                            </div>
                                                                        )}
                                                                    </ErrorMessage>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Grid item xs={4} md={2} className="marginAuto">
                                                                <Controls.Button>Submit</Controls.Button>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Form>
                                            )}
                                        </Formik>
                                    </div>
                                </Controls.Popup>
                            )}
                        </div>
                    </Container>
                </Grid>
                {alert.counter > 0 && (
                    <CustomizedSnackbars
                        status={alert.counter}
                        msg={alert.msg}
                        type={alert.type}
                    />
                )}
            </Grid>
        </Box >
    );
};

export default WhatsAppGroup;
